export const getLatestCourses = '/api/v1/courses?latest&limit=8';
export const getPopularCourses = '/api/v1/courses?popular&limit=8';
export const getPopularCollections = '/api/v1/collections?popular&limit=8';

export const getCourseOverview = slug => {
    return `/api/v1/courses/${slug}/overview`;
};

export const getCourseContent = slug => {
    return `/api/v1/courses/${slug}/content`;
};

export const getAssessmentQuestion = slug => {
    return `/api/v1/courses/${slug}/assessment`;
};